import Block from './Block';

import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    block: {
        textTransform: "uppercase",
    },
    caption: {
        color: theme.palette.secondary.muted,
        margin: 0,
        marginBottom: ".5rem",
        display: "block",
    },
    heading: {
        color: theme.palette.primary.main,
        margin: 0,
    },
    text: {
        margin: 0,
        marginTop: ".5rem",
    },
}));

export default function CategoryBlock({ heading, minHeight = "6em", text = "", ...props }) {

    const classes = useStyles();

    return (
        <Block className={classes.block} style={{minHeight}} {...props}>
            <Typography variant="h6" className={classes.heading}>{heading}</Typography>
            {text ?
                <Typography variant="body1" className={classes.text}>{text}</Typography>
                : ''
            }
        </Block>
    )
}